import {
  Box,
  ContentBlock,
  Stack,
  useResponsiveValue,
} from 'braid-design-system';
import type React from 'react';
import { useLocation } from 'react-router-dom';

import {
  MOBILE_INTERCEPT,
  VERIFICATION_CODE,
} from '../../../components/pages/LoginPage/hashRoutes';
import getHashRoute from '../../../utils/getHashRoute';
import { useAppContext } from '../../AppContext';
import HoldingPage from '../../pages/StaticHoldingPage/StaticHoldingPage';

import Footer from './Footer/Footer';
import Header from './Header/Header';

import * as styles from './styles.css';

interface Props {
  children: React.ReactNode;
}

const MainLayout = ({ children }: Props) => {
  const { isStaticRender, isMobileClient } = useAppContext();
  const location = useLocation();
  const locationHash = location.hash.substring(1);
  const mobileInterceptPath = getHashRoute(MOBILE_INTERCEPT);
  const verificationCodePath = getHashRoute(VERIFICATION_CODE);

  const responsiveValue = useResponsiveValue();
  const isTabletOrAbove = responsiveValue({
    mobile: false,
    desktop: true,
    tablet: true,
  });

  const isVerificationScreenOnMobile =
    verificationCodePath.includes(locationHash) && !isTabletOrAbove;

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent={
        isMobileClient || isVerificationScreenOnMobile
          ? 'center'
          : 'spaceBetween'
      }
      className={styles.content}
      background={isMobileClient ? 'surface' : undefined}
    >
      {mobileInterceptPath.includes(locationHash) ||
      isVerificationScreenOnMobile ? null : (
        <Stack space={['none', 'medium', 'medium']}>
          <Header />
        </Stack>
      )}
      <Box paddingBottom={['none', 'xlarge', 'xxlarge']}>
        <Stack space={['none', 'medium', 'medium']}>
          <ContentBlock width="small">
            {isStaticRender ? <HoldingPage /> : children}
          </ContentBlock>
        </Stack>
      </Box>
      {isMobileClient || isVerificationScreenOnMobile ? null : <Footer />}
    </Box>
  );
};

export default MainLayout;
